import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import API from "../../data/api/api";

// ================= FETCH COMPANY BLOGS =================

export const fetchCompanyBlogs = createAsyncThunk(
  "blog/fetchCompanyBlogs",
  async (comId, { rejectWithValue }) => {
    try {
      const response = await API.get(
        `/Blog/company-blogs?comId=${comId}`
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Something went wrong"
      );
    }
  }
);

// ================= FETCH BLOG BY ID =================

export const fetchBlogById = createAsyncThunk(
  "blog/fetchBlogById",
  async ({ id, comId }, { rejectWithValue }) => {
    try {
      const response = await API.get(
        `/Blog/company-blog/${id}?comId=${comId}`
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Something went wrong"
      );
    }
  }
);

// ================= SLICE =================

const blogSlice = createSlice({
  name: "blog",

  initialState: {
    loading: false,
    success: false,
    error: null,

    blogs: [],
    blogDetails: null,
  },

  reducers: {
    resetBlogState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.blogDetails = null;
    },
  },

  extraReducers: (builder) => {
    builder

      // FETCH BLOGS
      .addCase(fetchCompanyBlogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchCompanyBlogs.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.blogs = action.payload;
      })

      .addCase(fetchCompanyBlogs.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      })

      // FETCH BLOG BY ID
      .addCase(fetchBlogById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchBlogById.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.blogDetails = action.payload;
      })

      .addCase(fetchBlogById.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      });
  },
});

export const { resetBlogState } = blogSlice.actions;

export default blogSlice.reducer;